export default __webpack_public_path__ + "static/media/cafeshow_throo01.5ed3acf4.png";